import { __rest } from "tslib";
import { jsx as _jsx } from "preact/jsx-runtime";
import React, { useRef } from 'react';
import styles from '../styles/sitewideLogo.module.scss';
import clsx from 'clsx';
import { useSponsoredWidgetTracking } from 'pathfinder/utils/sponsoredWidgets/useSponsoredWidgetTracking';
import { SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant } from 'pathfinder/rules-engine/modules/sponsoredWidgetsSponsoredSitewideLogoConsumptionModule';
function variantToModuleName(variant) {
    switch (variant) {
        case SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant.DESKTOP:
            return 'sponsored-sitewide-logo-desktop';
        case SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant.MOBILE:
            return 'sponsored-sitewide-logo-mobile';
    }
}
const SitewideLogo = React.forwardRef((_a) => {
    var { imageUrl, url, isUrlExternal, track, logoid, variant } = _a, rest = __rest(_a, ["imageUrl", "url", "isUrlExternal", "track", "logoid", "variant"]);
    const logoRef = useRef(null);
    const logoTrackClickClick = useSponsoredWidgetTracking(track, logoid, variantToModuleName(variant), logoRef);
    return (_jsx("a", Object.assign({ className: "global-navigation__link", href: url, target: isUrlExternal ? '_blank' : undefined, rel: isUrlExternal ? 'nofollow' : undefined, 
        // @ts-expect-error preact Ref has different typings
        ref: logoRef, onClick: logoTrackClickClick }, rest, { children: _jsx("img", { className: clsx('global-navigation__icon global-navigation__link-icon', styles.sitewideLogo), src: imageUrl, alt: "Sponsored Logo" }, void 0) }), void 0));
});
export default React.memo(SitewideLogo);
